module.exports = __webpack_public_path__ + "img/FOL_program4.e967d02b.jpg";